import { TrackingPage } from './components/TrackingPage';

function parseLocation(): { orderNumber: string | null; token: string | null } {
  const path = window.location.pathname;
  const m = /\/order\/([^/]+)\/?$/.exec(path);
  const orderNumber = m && m[1] ? decodeURIComponent(m[1]) : null;
  const token = new URLSearchParams(window.location.search).get('t');
  return { orderNumber, token };
}

export function App() {
  const { orderNumber, token } = parseLocation();

  if (!orderNumber || !token) {
    return (
      <div className="min-h-full flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-semibold text-brand-700 mb-2">Tracking link is missing details</h1>
          <p className="text-gray-600 text-sm">
            The link from your WhatsApp message should look like
            <br />
            <code className="text-xs">https://tracking.mrfreshwheels.com/order/&lt;number&gt;?t=&lt;token&gt;</code>
            <br />
            Kindly open the link from the message we sent you.
          </p>
        </div>
      </div>
    );
  }

  return <TrackingPage orderNumber={orderNumber} token={token} />;
}
